import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useFetchClaimsManagerMetrics = (startDate, endDate, opts = {}) => {
  return useQuery(
    ['claims-manager-metrics', { startDate, endDate }],
    async () => {
      const res = await axios.get('/admin/metrics/claims-managers', {
        params: {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};

export const useFetchClaimsManagerMetricClaims = (
  managerId,
  metric,
  startDate,
  endDate,
  opts = {},
) => {
  return useQuery(
    ['claims-manager-metric-claims', { managerId, metric, startDate, endDate }],
    async () => {
      const res = await axios.get('/admin/metrics/claims-managers/claims', {
        params: {
          managerId,
          metric,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};

export const useFetchClaimsManagerRevenueDetails = (
  managerId,
  bucket,
  startDate,
  endDate,
  opts = {},
) => {
  return useQuery(
    ['claims-manager-revenue-details', { managerId, bucket, startDate, endDate }],
    async () => {
      const res = await axios.get('/admin/metrics/claims-managers/revenue-details', {
        params: {
          managerId: managerId || undefined,
          bucket: bucket || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};

export const useFetchOnboardingSpecialistMetrics = (startDate, endDate, opts = {}) => {
  return useQuery(
    ['onboarding-specialist-metrics', { startDate, endDate }],
    async () => {
      const res = await axios.get('/admin/metrics/onboarding', {
        params: {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};

export const useFetchOnboardingSpecialistMetricClaims = (
  onboardingUserId,
  metric,
  startDate,
  endDate,
  opts = {},
) => {
  return useQuery(
    ['onboarding-specialist-metric-claims', { onboardingUserId, metric, startDate, endDate }],
    async () => {
      const res = await axios.get('/admin/metrics/onboarding/claims', {
        params: {
          onboardingUserId,
          metric: metric || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};


